window._ = require('lodash');

/**
 * Load the axios http library allowing us to easily send requests to Craft.
 * We also configure axios to send the request data, including adding a
 * CSRF Token to any requests, in the correct format Craft requires.
 */

window.axios = require('axios');
let qs = require('qs');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

/**
 * We will include the CSRF Token in any data that is being sent by Axios so
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.interceptors.request.use(config => {
        if (config.data instanceof FormData) {
            config.data.append('CRAFT_CSRF_TOKEN', token.content);
        } else if (config.data === Object(config.data)) {
            config.data = qs.stringify(Object.assign({['CRAFT_CSRF_TOKEN']: token.content}, config.data.data));
        }

        return config;
    });
} else {
    console.error('CSRF token not found. Please add a "csrf-token" meta tag to the document head!');
}
